// ユーティリティ関数

// 変換データの検証と正規化
export const validateAndNormalizeTransform = (transform) => {
  try {
    const normalized = {
      scale: parseFloat(transform.scale) || 1,
      rotation: parseFloat(transform.rotation) || 0,
      offsetX: parseFloat(transform.offsetX) || 0,
      offsetY: parseFloat(transform.offsetY) || 0,
    };

    // 範囲チェック
    normalized.scale = Math.max(0.5, Math.min(3.0, normalized.scale));
    normalized.rotation = normalized.rotation % 360;
    if (normalized.rotation < 0) normalized.rotation += 360;

    // オフセットの範囲制限（極端な値を防ぐ）
    normalized.offsetX = Math.max(-1000, Math.min(1000, normalized.offsetX));
    normalized.offsetY = Math.max(-1000, Math.min(1000, normalized.offsetY));

    return normalized;
  } catch (error) {
    console.error(`[validateAndNormalizeTransform] 検証エラー:`, error);
    return null;
  }
};

// 変換データの比較
export const isTransformDataEqual = (transform1, transform2) => {
  const epsilon = 0.0001;
  return Math.abs(transform1.scale - transform2.scale) < epsilon && Math.abs(transform1.rotation - transform2.rotation) < epsilon && Math.abs(transform1.offsetX - transform2.offsetX) < epsilon && Math.abs(transform1.offsetY - transform2.offsetY) < epsilon;
};

// Q単位をピクセルに変換する関数
export const qToPixels = (qValue, scale) => {
  // 1Q = 0.25mm
  const mmValue = qValue * 0.25;
  return mmValue * scale;
};

// mm単位をピクセルに変換する関数
export const mmToPixels = (mmValue, scale) => {
  return mmValue * scale;
};

// テキストを複数行に分割する関数
export const wrapText = (ctx, text, maxWidth, maxLines = null) => {
  // 改行文字で分割
  const paragraphs = text.split(/\r\n|\r|\n/);
  const lines = [];

  for (const paragraph of paragraphs) {
    if (paragraph === "") {
      // 空行の場合
      lines.push("");
      if (maxLines && lines.length >= maxLines) break;
      continue;
    }

    // 各段落を文字単位で折り返し
    const words = paragraph.split("");
    let currentLine = "";

    for (let i = 0; i < words.length; i++) {
      const testLine = currentLine + words[i];
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;

      if (testWidth > maxWidth && currentLine !== "") {
        lines.push(currentLine);
        currentLine = words[i];

        // 最大行数に達した場合は終了
        if (maxLines && lines.length >= maxLines) {
          break;
        }
      } else {
        currentLine = testLine;
      }
    }

    if (currentLine !== "" && (!maxLines || lines.length < maxLines)) {
      lines.push(currentLine);
    }

    // 最大行数に達した場合は終了
    if (maxLines && lines.length >= maxLines) {
      break;
    }
  }

  return lines;
};

// フォント読み込み完了を待つ関数
export const waitForFonts = async () => {
  const fonts = ["UD新ゴ R"];
  try {
    // 各フォントの読み込み完了を待つ
    const fontPromises = fonts.map((fontFamily) => {
      return document.fonts.load(`16px "${fontFamily}"`);
    });

    await Promise.all(fontPromises);
    console.log("All fonts loaded successfully");
    return true;
  } catch (error) {
    console.warn("Font loading failed, using fallback fonts:", error);
    return false;
  }
};

// フォーム入力値を取得する関数
export const getFormTextValues = () => {
  // 実際のフォーム要素から値を取得
  const studentNameInput = document.querySelector('input[name="name"]');
  const departmentInput = document.querySelector('input[name="department"]');
  const courseInput = document.querySelector('input[name="course"]');
  const titleInput = document.getElementById("mase_case_entry_type_a1_itemStrVarchar01");
  const messageInput = document.getElementById("mase_case_entry_type_a1_itemStrText02");

  return {
    studentName: studentNameInput ? studentNameInput.value : "",
    department: departmentInput ? departmentInput.value : "",
    course: courseInput ? courseInput.value : "",
    title: titleInput ? titleInput.value : "",
    message: messageInput ? messageInput.value : "",
  };
};
